import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Box,
  Tooltip
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'; // Trophy
import SpellcheckIcon from '@mui/icons-material/Spellcheck';
import { useStats } from './hooks/useStats';

const Navbar = ({ user, onLogin, onLogout }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { stats, loading } = useStats();

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const StatsContent = () => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Tooltip title="Total de Pontos">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <EmojiEventsIcon fontSize="small" />
          <Typography variant="body2">
            {loading ? '...' : stats?.stats?.total_points || 0}
          </Typography>
        </Box>
      </Tooltip>
      <Tooltip title="Total de Palavras">
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <SpellcheckIcon fontSize="small" />
          <Typography variant="body2">
            {loading ? '...' : stats?.stats?.total_words || 0}
          </Typography>
        </Box>
      </Tooltip>
    </Box>
  );

  const DesktopMenu = () => (
    <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2, alignItems: 'center' }}>
      {user ? (
        <>
          <StatsContent />
          <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <PersonIcon />
            <Typography>{user.name}</Typography>
          </Box>
          <Button 
            color="inherit" 
            onClick={onLogout}
            startIcon={<LogoutIcon />}
          >
            Sair
          </Button>
        </>
      ) : (
        <Button 
          color="inherit" 
          onClick={onLogin}
          startIcon={<LoginIcon />}
        >
          Entrar
        </Button>
      )}
    </Box>
  );

  const MobileMenu = () => (
    <List>
      {user ? (
        <>
          <ListItem>
            <ListItemIcon>
              <EmojiEventsIcon />
            </ListItemIcon>
            <ListItemText 
              primary="Total de Pontos"
              secondary={loading ? '...' : stats?.stats?.total_points || 0}
            />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <SpellcheckIcon />
            </ListItemIcon>
            <ListItemText 
              primary="Total de Palavras"
              secondary={loading ? '...' : stats?.stats?.total_words || 0}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <ListItemText primary={user.name} />
          </ListItem>
          <ListItem button onClick={onLogout}>
            <ListItemIcon>
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary="Sair" />
          </ListItem>
        </>
      ) : (
        <ListItem button onClick={onLogin}>
          <ListItemIcon>
            <LoginIcon />
          </ListItemIcon>
          <ListItemText primary="Entrar" />
        </ListItem>
      )}
    </List>
  );

  return (
    <>
      <AppBar position="fixed">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Junta Letras
          </Typography>
          
          <DesktopMenu />

          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ display: { md: 'none' } }}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="temporary"
        anchor="right"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true
        }}
        sx={{
          display: { xs: 'block', md: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: 240 }
        }}
      >
        <MobileMenu />
      </Drawer>

      <Toolbar />
    </>
  );
};

export default Navbar;
